import { Box, CircularProgress, Typography } from '@mui/material';
import moment from 'moment';
import { useContext, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import BaseImage from '../../components/common/baseImage';
import { AudioPlayContext } from '../../contexts/AudioPlayContext';
import { SoundList } from '../../models/Voice';
import { LocalState } from '../../models/games/enums/LocalState';
import { RootState } from '../../store/store';
import { getLocalState as getBaccLocalState } from '../../utils/games/baccarat';
import { getLocalState as getAndarBaharLocalState } from '../../utils/games/andarBahar';
import { getLocalState as getBlackjackLocalState } from '../../utils/games/blackjack';
import { getLocalState as getDragonTigerLocalState } from '../../utils/games/dragonTiger';
import { getLocalState as getSedieLocalState } from '../../utils/games/sedie';
import { getLocalState as getSicboLocalState } from '../../utils/games/sicbo';
import { getLocalState as getTeenpattiLocalState } from '../../utils/games/teenpatti';
import { getHostById } from '../host/slice';
import { GameType as GameTypeEnum } from '../../models/games/enums/GameType';

const CountdownColor = ['0,148,97', '148,132,0', '148,0,0']; //009461, 948400, 940000
type Props = {
    hostId: number;
};
export const InGameCountdown = (props: Props) => {
    const { hostId } = props;
    const { audioPlay } = useContext(AudioPlayContext);
    const host = useSelector((state: RootState) => getHostById(state, hostId));
    const { IsRest, CurrentState, ResultReleased, RemainTime, CountDown } =
        host;
    const totalTime = Math.round((CountDown || 0) / 1000);
    const [timer, setTimer] = useState<number>(-1);
    const Ref = useRef<NodeJS.Timeout>();
    const [localState, setLocalState] = useState<number>(-1);
    const [countdownColor, setCountdownColor] = useState<string>(
        CountdownColor[0]
    );
    const startTimer = () => {
        if (timer > 0) {
            const cTimer = timer - 1;
            if (cTimer <= 5) {
                audioPlay(SoundList.Beep);
            }
            setTimer(cTimer);
            const rate = cTimer / totalTime;
            if (rate >= 0.67) {
                setCountdownColor(CountdownColor[0]);
            } else if (rate >= 0.34) {
                setCountdownColor(CountdownColor[1]);
            } else {
                setCountdownColor(CountdownColor[2]);
            }
        }
    };

    const clearTimer = () => {
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer();
        }, 1000);
        Ref.current = id;
    };

    const getLocalState = () => {
        switch (host.GameType) {
            case GameTypeEnum.Baccarat:
                return getBaccLocalState(
                    IsRest,
                    CurrentState,
                    ResultReleased,
                    false
                );
            case GameTypeEnum.AndarBahar:
                return getAndarBaharLocalState(
                    IsRest,
                    CurrentState,
                    ResultReleased
                );
            case GameTypeEnum.Dragon:
                return getDragonTigerLocalState(
                    IsRest,
                    CurrentState,
                    ResultReleased
                );
            case GameTypeEnum.Blackjack:
                return getBlackjackLocalState(
                    IsRest,
                    CurrentState,
                    ResultReleased
                );
            case GameTypeEnum.SeDie:
                return getSedieLocalState(IsRest, CurrentState, ResultReleased);
            case GameTypeEnum.SicBo:
                return getSicboLocalState(IsRest, CurrentState, ResultReleased);
            case GameTypeEnum.TeenPatti2020:
                return getTeenpattiLocalState(
                    IsRest,
                    CurrentState,
                    ResultReleased
                );
            default:
                return getSicboLocalState(IsRest, CurrentState, ResultReleased);
        }
    };

    useEffect(() => {
        setLocalState(getLocalState());
    }, [IsRest, CurrentState, ResultReleased]);

    useEffect(() => {
        if (localState === LocalState.BETTING) {
            const curTimer = Math.max(
                0,
                Math.round((RemainTime - moment().valueOf()) / 1000)
            );
            setTimer(curTimer);
            clearTimer();
        } else {
            setTimer(localState > -1? 0:-1);
        }
        return () => {
            if (Ref.current) clearInterval(Ref.current);
        };
    }, [localState, timer, RemainTime, totalTime]);
    return (
        <>
            {timer >= 0 && (
                <Box
                    sx={{
                        position: 'relative',
                        display: 'inline-flex',
                        width: '90.092px', //scale 0.446 = 202*0.446
                        height: '90.092px',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <CircularProgress
                        variant="determinate"
                        size={80.092} //80.092 = 90.092-10
                        value={100 - ((totalTime - timer) / totalTime) * 100}
                        thickness={1}
                        sx={{
                            color: `rgba(${countdownColor})`,
                            zIndex: 1,
                            scale: '-1 1',
                        }}
                    />
                    <Box
                        sx={{
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: 'absolute',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '90.092px',
                            height: '90.092px',
                        }}
                    >
                        <Box
                            sx={{
                                width: '90.092px',
                                height: '90.092px',
                                position: 'absolute',
                            }}
                        >
                            <BaseImage
                                className="commonUI timer_base"
                                scale={0.892} //0.892 = 90.092/101
                            />
                        </Box>
                        <Typography
                            variant="caption"
                            component="div"
                            color="#ffffff"
                            fontSize={'50px'}
                            zIndex={1}
                        >
                            {timer}
                        </Typography>
                    </Box>
                </Box>
            )}
        </>
    );
};
